import React, {useEffect, useState} from "react";
import DashboardLayout from "../../../layouts/Dashboard";
import { useTranslation } from "react-i18next";
import { SearchPanel, TableCustom } from "../../../components";
import VisibilityIcon from "@mui/icons-material/Visibility";
import EditIcon from "@mui/icons-material/Edit";
import DeleteForeverIcon from "@mui/icons-material/DeleteForever";
import Box from "@mui/material/Box";
import { Button } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { getGenders, addGender, editGender, deleteGender, getGenderByKey } from "../../../redux/actions/genderActions";
import CreateGender from "./Popups/CreateGender";
import GenderDetails from "./Popups/GenderDetails";
import EditGender from "./Popups/EditGender";
import RemoveGender from "./Popups/RemoveGender";

function createData(id, name, code, description) {
    return {id, name, code, description};
}

let rows = [
    createData(1, "abc", "abc", "abc"),
];
const GenderList = () => {
    const {t} = useTranslation();
    const rowName = [
        {text: t("genderList.tableItem.id")},
        {text: t("genderList.tableItem.name")},
        {text: t("genderList.tableItem.code")},
        {text: t("genderList.tableItem.description")},
        {text: t("genderList.tableItem.actions")},
    ];
    const dispatch = useDispatch();

    const [query, setQuery] = useState({ "sort": { "id": { "operator": "asc" } } });

    const [id, setId] = useState(null);
    const [createOpen, setCreateOpen] = useState(false);
    const setCreateHandler = async () => {
        setCreateOpen(false);
        setDetailsOpen(false);
        setEditOpen(false);
        setRemoveOpen(false);
        setCreateOpen(true);
        setId(null);
    }
    const createSubmit = async (_) => {
        await dispatch(addGender(_, query));
    }
    const [detailsOpen, setDetailsOpen] = useState(false);
    const setDetailsHandler = async (id) => {
        await dispatch(getGenderByKey(id));
        setCreateOpen(false);
        setDetailsOpen(false);
        setEditOpen(false);
        setRemoveOpen(false);
        setDetailsOpen(true);
        setId(id);
    }
    
    const [editOpen, setEditOpen] = useState(false);
    const setEditHandler = async (id) => {
        await dispatch(getGenderByKey(id));
        setCreateOpen(false);
        setDetailsOpen(false);
        setEditOpen(false);
        setRemoveOpen(false);
        setEditOpen(true);
        setId(id);
    }
    const editSubmit = async (_) => {
        await dispatch(editGender(_, query));
    }
    const [removeOpen, setRemoveOpen] = useState(false);
    const setRemoveHandler = async (id) => {
        await dispatch(getGenderByKey(id));
        setCreateOpen(false);
        setDetailsOpen(false);
        setEditOpen(false);
        setRemoveOpen(false);
        setRemoveOpen(true);
        setId(id);
    }
    const removeSubmit = async (_) => {
        await dispatch(deleteGender(_.id, query));
    }

    const localData = false;
    const state = useSelector((state) => state.gender);
    if (!localData && state.genders)
    {
        rows = state.genders;
    }
    useEffect(() => {
        if (!localData)
        {
            dispatch(getGenders(query));
        }
    }, [dispatch]);
    return (
        <DashboardLayout>
            <Box sx={{margin: '20px 0', display: 'flex', justifyContent: 'space-between', alignItems: 'center'}}>
                <SearchPanel searchName="id" search={rows} label={t("genderList.searchLabel")}/>
                <Button color="primary" variant="contained" onClick={() => setCreateHandler()}>
                    {t("genderList.createText")}
                </Button>
            </Box>
            <TableCustom avatars={false} rowName={rowName} rows={rows.map(_ => {
                return {
                    id: _.id,
                    name: _.name,
                    code: _.code,
                    description: _.description,
                }
            })} actions={(_) => [<VisibilityIcon onClick={() => setDetailsHandler(_.id)}/>,<EditIcon onClick={() => setEditHandler(_.id)}/>,<DeleteForeverIcon onClick={() => setRemoveHandler(_.id)}/>]}/>
            <CreateGender action={'create'} title={t("genderList.createText")} open={createOpen} setOpen={setCreateOpen} onSubmit={createSubmit}/>
            <GenderDetails action={'details'} title={t("genderList.detailsText")} open={detailsOpen} setOpen={setDetailsOpen} />
            <EditGender action={'edit'} title={t("genderList.editText")} open={editOpen} setOpen={setEditOpen} onSubmit={editSubmit}/>
            <RemoveGender action={'remove'} title={t("genderList.removeText")} open={removeOpen} setOpen={setRemoveOpen} onSubmit={removeSubmit}/>
        </DashboardLayout>
    )
};

export default GenderList;
